(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
document.addEventListener('submit', function(event) {
  const form = event.target;
  if (!form.matches('[data-collection-controls]')) return;
  event.preventDefault();
  const url = new URL(window.location.href);
  url.searchParams.delete('page');
  for (const key of Array.from(url.searchParams.keys())) {
    if (key.startsWith('filter.') || key === 'sort_by' || key === 'view') url.searchParams.delete(key);
  }
  for (const [key, value] of new FormData(form)) {
    if (typeof value === 'string' && value !== '') url.searchParams.append(key, value);
  }
  url.hash = '';
  window.location.assign(url.toString());
});
document.addEventListener('change', function(event) {
  const select = event.target;
  if (!select.matches('[data-collection-controls] select')) return;
  if (select.name === 'view') {
    const browser = select.closest('.collection-browser');
    for (const sibling of browser.querySelectorAll('select[name="view"]')) sibling.value = select.value;
  }
  select.form.requestSubmit();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-gallery-direction]');
  if (!button) return;
  const gallery = button.closest('.product-media').querySelector('.product-gallery');
  gallery.scrollBy({left: gallery.clientWidth * Number(button.dataset.galleryDirection), behavior: 'smooth'});
});
document.addEventListener('change', function (event) {
  if (!event.target.matches('[data-product-select]')) return;
  const gallery = event.target.closest('.product-main').querySelector('.product-gallery');
  if (gallery) gallery.scrollTo({left: 0});
});

  } catch(e) { console.error(e); }
})();
})();
